/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ClientPermissionViewModel } from '../models/client-permission-view-model';
import { ClientRoleViewModel } from '../models/client-role-view-model';
import { ClientUserViewModel } from '../models/client-user-view-model';
import { ClientUserViewModelPrimeDatatableResults } from '../models/client-user-view-model-prime-datatable-results';
import { Get } from '../fn/client-users/get';
import { Get$Params } from '../fn/client-users/get';
import { GetClientPermissions } from '../fn/client-users/get-client-permissions';
import { GetClientPermissions$Params } from '../fn/client-users/get-client-permissions';
import { List } from '../fn/client-users/list';
import { List$Params } from '../fn/client-users/list';
import { ResetAccessCredentials } from '../fn/client-users/reset-access-credentials';
import { ResetAccessCredentials$Params } from '../fn/client-users/reset-access-credentials';
import { Save } from '../fn/client-users/save';
import { Save$Params } from '../fn/client-users/save';
import { SaveClientPermission } from '../fn/client-users/save-client-permission';
import { SaveClientPermission$Params } from '../fn/client-users/save-client-permission';
import { SavePassword } from '../fn/client-users/save-password';
import { SavePassword$Params } from '../fn/client-users/save-password';
import { Search } from '../fn/client-users/search';
import { Search$Params } from '../fn/client-users/search';
import { SearchRoles } from '../fn/client-users/search-roles';
import { SearchRoles$Params } from '../fn/client-users/search-roles';

@Injectable({ providedIn: 'root' })
export class ClientUsersApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiClientUsersClientIdListPost()` */
  static readonly ApiClientUsersClientIdListPostPath = '/api/ClientUsers/{clientID}/List';

  /**
   * List Client Users.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params: List$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * List Client Users.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params: List$Params, context?: HttpContext): Observable<ClientUserViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientUserViewModelPrimeDatatableResults>): ClientUserViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdGetPost()` */
  static readonly ApiClientUsersClientIdGetPostPath = '/api/ClientUsers/{clientID}/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientUserViewModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params: Get$Params, context?: HttpContext): Observable<ClientUserViewModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientUserViewModel>): ClientUserViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdSavePost()` */
  static readonly ApiClientUsersClientIdSavePostPath = '/api/ClientUsers/{clientID}/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params: Save$Params, context?: HttpContext): Observable<void> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdSavePasswordPost()` */
  static readonly ApiClientUsersClientIdSavePasswordPostPath = '/api/ClientUsers/{clientID}/SavePassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SavePassword()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePassword$Response(params: SavePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SavePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SavePassword$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SavePassword(params: SavePassword$Params, context?: HttpContext): Observable<void> {
    return this.SavePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdResetAccessCredentialsIdPost()` */
  static readonly ApiClientUsersClientIdResetAccessCredentialsIdPostPath = '/api/ClientUsers/{clientID}/ResetAccessCredentials/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ResetAccessCredentials()` instead.
   *
   * This method doesn't expect any request body.
   */
  ResetAccessCredentials$Response(params: ResetAccessCredentials$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return ResetAccessCredentials(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ResetAccessCredentials$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ResetAccessCredentials(params: ResetAccessCredentials$Params, context?: HttpContext): Observable<void> {
    return this.ResetAccessCredentials$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdSearchPost()` */
  static readonly ApiClientUsersClientIdSearchPostPath = '/api/ClientUsers/{clientID}/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Search()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Search$Response(params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientUserViewModel>>> {
    return Search(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Search$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Search(params: Search$Params, context?: HttpContext): Observable<Array<ClientUserViewModel>> {
    return this.Search$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientUserViewModel>>): Array<ClientUserViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdSaveClientPermissionPost()` */
  static readonly ApiClientUsersClientIdSaveClientPermissionPostPath = '/api/ClientUsers/{clientID}/SaveClientPermission';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveClientPermission()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientPermission$Response(params: SaveClientPermission$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientPermissionViewModel>> {
    return SaveClientPermission(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveClientPermission$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveClientPermission(params: SaveClientPermission$Params, context?: HttpContext): Observable<ClientPermissionViewModel> {
    return this.SaveClientPermission$Response(params, context).pipe(
      map((r: StrictHttpResponse<ClientPermissionViewModel>): ClientPermissionViewModel => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdGetClientPermissionsGet()` */
  static readonly ApiClientUsersClientIdGetClientPermissionsGetPath = '/api/ClientUsers/{clientID}/GetClientPermissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetClientPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientPermissions$Response(params: GetClientPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientPermissionViewModel>>> {
    return GetClientPermissions(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetClientPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetClientPermissions(params: GetClientPermissions$Params, context?: HttpContext): Observable<Array<ClientPermissionViewModel>> {
    return this.GetClientPermissions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientPermissionViewModel>>): Array<ClientPermissionViewModel> => r.body)
    );
  }

  /** Path part for operation `apiClientUsersClientIdSearchRolesPost()` */
  static readonly ApiClientUsersClientIdSearchRolesPostPath = '/api/ClientUsers/{clientID}/SearchRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SearchRoles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SearchRoles$Response(params: SearchRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientRoleViewModel>>> {
    return SearchRoles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SearchRoles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SearchRoles(params: SearchRoles$Params, context?: HttpContext): Observable<Array<ClientRoleViewModel>> {
    return this.SearchRoles$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientRoleViewModel>>): Array<ClientRoleViewModel> => r.body)
    );
  }

}
